// Indian mobile helpers — every phone field on the site stores/sends +91XXXXXXXXXX.
export const nationalDigits = (raw) => {
  let s = String(raw || '').trim();
  if (s.startsWith('+91')) s = s.slice(3); // partial '+91XXX' values emitted while typing
  let d = s.replace(/\D/g, '');
  if (d.length > 10) d = d.slice(-10); // strips +91 / 91 / 0 prefixes from pasted numbers
  return d;
};

export const toE164 = (raw) => {
  const d = nationalDigits(raw);
  return d ? `+91${d}` : '';
};

export const isValidIndianMobile = (raw) => /^[6-9]\d{9}$/.test(nationalDigits(raw));

export const formatIndianMobile = (raw) => {
  const d = nationalDigits(raw);
  return d.length === 10 ? `+91 ${d.slice(0, 5)} ${d.slice(5)}` : raw || '';
};
